import React from 'react';
import { Icon } from '@/Components/Icon/Icon';
import { Icons } from '@/Static/IconsRes';
import Button from 'devextreme-react/button';
import styles from './TableImportButton.scss';
import { useLocalization } from '@/Hooks';
import { Tooltip } from '@/Components/Tooltip/Tooltip';

export const TableImportButton = (): React.ReactElement => {
  const {
    common: {
      Actions: { ImportData },
    },
  } = useLocalization();

  return (
    <Tooltip text={ImportData}>
      <Button className={styles.button} disabled>
        <Icon alt="clearFiltersIcon" src={Icons.Incoming} className={styles.icon} id="tableImportButton" />
      </Button>
    </Tooltip>
  );
};
